import { render, staticRenderFns } from "./templatePreview.vue?vue&type=template&id=4d9586e4"
import script from "./templatePreview.vue?vue&type=script&lang=js"
export * from "./templatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports